import router from './router'
import cybercrimeMessages from './localization'

export default {
  router,
  localization: cybercrimeMessages,
}
